<template>
  <div class="typicalParamDetail">
    <div style="margin-top: 60px">
      <el-form :inline="true" label-width="80px">
        <el-form-item label="设备类型">
          <el-input v-model="this.dictOptionName" style="width: 160px" disabled></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div>
      <el-card shadow="never">
        <el-table :data="tableData" ref="typicalParamTable" max-height="500" border tooltip-effect="dark" :key="componentKey">
          <el-table-column type="index" label="序号" width="140"></el-table-column>
          <el-table-column prop="tyDPName" label="典型数据点名称">
            <template slot-scope="{ row }">
              <div @dblclick="toggleTyDPName(row)">
                <el-input v-if="row.tyDPNameEdit && isType === 'edit'" v-model="row.tyDPName" @input="updateTyDPName(row)"></el-input>
                <div v-else>
                  <span v-if="isType === 'edit'" class="device-points">
                    {{ row.tyDPName && row.tyDPName !== '-' ? row.tyDPName : '双击 编辑数据点名称'}}</span>
                  <span v-else>{{ row.tyDPName}}</span>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="tyDPDesc" label="典型数据点描述">
            <template slot-scope="{ row }">
              <div @dblclick="toggleTyDPDesc(row)">
                <el-input v-if="row.tyDPDescEdit && isType === 'edit'" v-model="row.tyDPDesc" @input="updateTyDPDesc(row)"></el-input>
                <div v-else>
                  <span v-if="isType === 'edit'" class="device-points">
                    {{ row.tyDPDesc && row.tyDPDesc !== '-' ? row.tyDPDesc : '双击 编辑数据点描述'}}</span>
                  <span v-else>{{ row.tyDPDesc}}</span>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
    </div>
    <div class="tools" v-show="isShowConfirmButton">
      <el-button type="primary" @click="saveForm">保存</el-button>
      <el-button type="primary" @click="cancel">取消</el-button>
    </div>
  </div>
</template>

<script>
  import TYPICALPARAMAPI from '@/api/typicalParam';

  export default {
    props: {
      equipType: {                        // 设备类型id
        type: [String, Number]
      },
      dictOptionName: {                   // 设备类型描述
        type: [String, Number]
      },
      isType: {
        type: [String, Number]
      }
    },
    data() {
      return {
        loading: false,
        componentKey: 0,
        isShowConfirmButton: false,

        tableData: [],                        // 典型参数列表
        originalTyDPNames: [],                // 典型参数列表-典型数据点[]
        originalTyDPDescs: [],                // 典型参数列表-典型数据点描述[]

        currOptionId: 0,
        currTyDPName: '',                     // 当前编辑行-最新输入的典型参数名称
        currTyDPDesc: '',                     // 当前编辑行-最新输入的典型参数描述
        currOriginTyDPName: '',               // 双击典型参数名称后，保存修改前典型参数名称的内容
        currOriginTyDPDesc: '',               // 双击典型参数描述后，保存修改前典型参数描述的内容
      };
    },
    components: {},
    created() {
      this.getEquipTypicalParamListByEquipType();     // 获取典型参数列表
    },
    watch: {},
    computed: {},
    methods: {

      // 获取指定设备类型-典型参数
      getEquipTypicalParamListByEquipType() {
        this.loading = true;
        let params = {
          equipType: this.equipType,
        };
        TYPICALPARAMAPI.getEquipTypicalParamListByEquipType(params).then(res => {
          if (res.data.code === 200 && !res.data.errors) {
            this.tableData = res.data.data;

            this.tableData = this.tableData.map(item => {
              item.tyDPNameEdit = false;
              item.tyDPDescEdit = false;
              return item;
            });

            this.originalTyDPNames = this.tableData.map(item => item.tyDPName);
            this.originalTyDPDescs = this.tableData.map(item => item.tyDPName);
          }
          if (res.data.errors) {
            this.$message.error(res.data.errors);
          }
        });
        this.loading = false;
      },

      // 双击典型数据点名称单元格
      toggleTyDPName(row) {
        this.isShowConfirmButton = this.isType === 'edit';
        row.tyDPNameEdit = true;
        this.currOptionId = row.id;
        this.currTyDPName = row.tyDPName;
        this.currTyDPDesc = row.tyDPDesc;
        this.currOriginTyDPName = row.tyDPName;
                                                      // 双击后，仅该行可编辑，其他行切换为不可编辑
        this.tableData.forEach(item => {
          if (item.id !== this.currOptionId) {
            item.tyDPNameEdit = false;
            item.tyDPDescEdit = false;
          }
        });
        this.componentKey += 1;
      },

      // 双击典型数据点名称单元格
      toggleTyDPDesc(row) {
        this.isShowConfirmButton = this.isType === 'edit';
        row.tyDPDescEdit = true;
        this.currOptionId = row.id;
        this.currTyDPName = row.tyDPName;
        this.currTyDPDesc = row.tyDPDesc;
        this.currOriginTyDPDesc = row.tyDPDesc;
                                                      // 双击后，仅该行可编辑，其他行切换为不可编辑
        this.tableData.forEach(item => {
          if (item.id !== this.currOptionId) {
            item.tyDPNameEdit = false;
            item.tyDPDescEdit = false;
          }
        });
        this.componentKey += 1;
      },

      // 修改数据点名称
      updateTyDPName(row) {
        this.currTyDPName = row.tyDPName;
      },

      // 修改数据点描述
      updateTyDPDesc(row) {
        this.currTyDPDesc = row.tyDPDesc;
      },

      saveForm() {
        const params = {
          id: this.currOptionId,
          tyDPName: this.currTyDPName !== '' ? this.currTyDPName : this.currOriginTyDPName,
          tyDPDesc: this.currTyDPDesc !== '' ? this.currTyDPDesc : this.currOriginTyDPDesc,
        };

        // 保存典型数据点名称
        if (params.currTyDPName === '') {
          this.$message.warning('典型数据点名称不能为空！');
        } else if (params.currTyDPDesc === '') {
          this.$message.warning('典型数据点描述不能为空！');
        } else {
          // 分别验证修改的典型参数名称、描述是否已存在，不能重名，未修改或 '-' 可以正常保存
          let isFindName = false;
          if ( this.originalTyDPNames.includes(params.currTyDPName) &&
            this.currOriginTyDPName !== params.currTyDPName) {
            isFindName = true;
          }

          let isFindDecs = false;
          if ( this.originalTyDPDescs.includes(params.currTyDPDesc) &&
            this.currOriginTyDPDesc !== params.currTyDPDesc) {
            isFindDecs = true;
          }

          if (!isFindName && !isFindDecs) {
            TYPICALPARAMAPI.updateEquipTypicalParamInfoList(params).then(res => {
              if (res.data.code === 200) {
                this.$message.success('操作成功');
                this.tableData = this.tableData.map(item => {
                  item.tyDPNameEdit = false;
                  item.tyDPNameEdit = false;
                  return item;
                });
                this.getEquipTypicalParamListByEquipType();
                this.isShowConfirmButton = false;
                this.currOptionId = '';
                this.currTyDPName = '';
                this.currTyDPDesc = '';
              }
            });
          }

          if (!isFindName && isFindDecs) {
            this.$message.warning('典型数据点描述 "'+ params.currTyDPDesc +'" 已存在！');
          }

          if (isFindName && !isFindDecs) {
            this.$message.warning('典型数据点名称 "'+ params.currTyDPName +'" 已存在！');
          }

          if (isFindName && isFindDecs) {
            this.$message.warning(
              '典型数据点名称 "'+ params.currTyDPName +'" 已存在，'
              + '典型数据点描述 "'+ params.currTyDPDesc +'" 已存在！'
            );
          }
        }
      },

      // 取消
      cancel() {
        this.getEquipTypicalParamListByEquipType();
        this.componentKey += 1;
        this.isShowConfirmButton = false;
      },
    }
  };
</script>

<style lang="scss">
  .typicalParamDetail {

    .el-card__body {
      padding: 0.0rem;
    }

    .tools {
      text-align: center;
      margin-top: 30px;
    }

    .device-points {
      color: #0261e4;

      &:hover {
        cursor: pointer;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/boss/typicalParamConfiguration/typicalParamDetail.vue